module.exports = __webpack_public_path__ + "static/media/17_tn.74d49692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/17_tn.jpg
// module id = 155
// module chunks = 0